export class Event {
    name;
    constructor(eventName) {
        this.name = eventName;
    }
}
